import ApiService from '@/data/services/ApiService'
import { IPlayerStatus, IServiceResponse } from '@/data/models'
import { AxiosResponse } from 'axios'

export class PlayerStatusApiService extends ApiService {
  static async getAll(): Promise<IServiceResponse<IPlayerStatus[]>> {
    return this.axios.get('player-statuses')
      .then((response: AxiosResponse<IServiceResponse<IPlayerStatus[]>>) => response.data)
  }
}
